// Seeded PRNG (mulberry32). The engine never calls Math.random(), so a game
// can be replayed exactly from its seed and the inputs - which is what makes
// the tests possible, and what a bug report's attached state is good for.

export function nextRandom(state) {
  let t = (state.rng += 0x6d2b79f5) | 0;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}
